<template>
    <div class="modal fade" :class="{'is-open': open}">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
                    <h3 class="modal-title">客戶通聯資料</h3>
                </div>
                <div class="modal-body">
                    <table class="table insurance-green">
                        <tr>
                            <th class="text-green text-right" width="120">類別</th>
                            <th class="text-green">項目</th>
                            <th class="text-green">內容</th>
                            <th class="text-green">管道</th>
                            <th class="text-green">更新時間</th>
                        </tr>
                        <tr>
                            <th class="text-green text-right" rowspan="2">手機號碼</th>
                            <td>電話號碼 1</td>
                            <td>0912123456</td>
                            <td>要保書檔</td>
                            <td>108/03/22 08:30:00.0</td>
                        </tr>
                        <tr>
                            <td>電話號碼 2</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <th class="text-green text-right" rowspan="4">電話號碼</th>
                            <td>住家電話號碼</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>公司電話號碼</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>聯絡電話號碼</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>最新一支電話號碼</td>
                            <td>0912123456</td>
                            <td>要保書檔</td>
                            <td>108/03/22 08:30:00.0</td>
                        </tr>
                        <tr>
                            <th class="text-green text-right" rowspan="4">地址</th>
                            <td>收費地址</td>
                            <td>123台北市仁愛路四段296號</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>戶籍地址</td>
                            <td>123台北市仁愛路四段296號</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>聯絡地址</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>最新一筆地址</td>
                            <td>123台北市仁愛路四段296號</td>
                            <td>保戶_收費地址</td>
                            <td>108/03/22 08:30:00.0</td>
                        </tr>
                        <tr>
                            <th class="text-green text-right" rowspan="4">email</th>
                            <td>email</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </table>
                    <p>資料來源依據單一資料庫，僅供查詢聯繫保戶使用，如資料有誤，請填聯繫單或A4變更申請書修正</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ConnectDataModal',
    props: {
        open: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
        }
    }
}
</script>

<style>

</style>
